"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _antd = require("antd");
var _button = _interopRequireDefault(require("../button/button.js"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function SignInFields(props) {
  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    props.form.validateFields(function (err, values) {
      if (!err) props.signIn(values);
    });
  };
  var _ref = props.form || "signIn",
    getFieldDecorator = _ref.getFieldDecorator;
  return /*#__PURE__*/_react["default"].createElement(_antd.Form, {
    onSubmit: handleSubmit,
    className: "login-form"
  }, /*#__PURE__*/_react["default"].createElement("h2", null, "Sign in"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "auth-switcher"
  }, "or ", /*#__PURE__*/_react["default"].createElement("a", {
    href: "",
    onClick: function onClick(e) {
      props.formSwitcher(e, "SignUp");
    }
  }, "create an account")), /*#__PURE__*/_react["default"].createElement(_antd.Form.Item, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "input-label"
  }, "Email"), getFieldDecorator("email", {
    rules: [{
      required: true,
      message: "Enter a valid email address."
    }]
  })( /*#__PURE__*/_react["default"].createElement(_antd.Input, {
    placeholder: "Enter email"
  }))), /*#__PURE__*/_react["default"].createElement(_antd.Form.Item, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "input-label"
  }, "Password"), getFieldDecorator("password", {
    rules: [{
      required: true,
      message: "Enter Password."
    }]
  })( /*#__PURE__*/_react["default"].createElement(_antd.Input, {
    type: "password",
    placeholder: "Enter password"
  }))), /*#__PURE__*/_react["default"].createElement(_antd.Form.Item, null, /*#__PURE__*/_react["default"].createElement(_button["default"], {
    label: "Sign in",
    primary: true,
    htmlType: "submit",
    wide: true
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "recover-link"
  }, /*#__PURE__*/_react["default"].createElement(_button["default"], {
    label: "Forgot password",
    text: true,
    wide: true,
    href: "",
    onClick: function onClick(e) {
      props.formSwitcher(e, "RecoverPassword");
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "1fr auto 1fr",
      alignItems: "center",
      width: "100%"
    }
  }, /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      margin: "0 10px"
    }
  }, "or"), /*#__PURE__*/_react["default"].createElement("hr", null))), /*#__PURE__*/_react["default"].createElement(_antd.Form.Item, null, /*#__PURE__*/_react["default"].createElement(_button["default"], {
    className: "socialAuth",
    label: "Sign in with Google",
    google: true,
    wide: true
  }), /*#__PURE__*/_react["default"].createElement(_button["default"], {
    label: "Sign in with Facebook",
    className: "socialAuth",
    facebook: true,
    wide: true
  })));
}
var _default = exports["default"] = SignInFields;